module.exports = __webpack_public_path__ + "img/supervivencia2.0a9bbdf6.webp";